import Icon from '../components/Icon.vue'

Icon.register({
  'person-booth': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M192 496v-176h64v176c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM224 224c17.7 0 32 14.3 32 32s-14.3 32-32 32h-57.5c-12.8 0-24.8-5-33.9-14.1l-20.9-20.9v80.6l41.2 61.3c4.4 8.8 6.7 18.7 6.7 28.6v56.5c0 17.7-14.3 32-32 32-17.7 0-32-14.3-32-32v-56l-29.1-43c-0.9-0.4-1.6-1.2-2.5-1.7l-0.1 100.7c0 17.7-14.4 32-32 32-17.6 0-31.9-14.3-31.9-32l0.2-160-0.2-95.9c0-17.1 6.7-33.2 18.7-45.3 12.1-12.1 28.2-18.8 45.3-18.8h18.7c17 0 33.1 6.6 45.2 18.7l45.2 45.3h50.9zM64 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM288 32v-32h192v416c0 17.7-14.3 32-32 32s-32-14.3-32-32c0 17.7-14.3 32-32 32-17.1 0-30.8-13.5-31.7-30.4-4.3 21.3-17.1 30.4-32.3 30.4-18.4 0-35.7-16.7-31.4-38.3l30.9-154.6zM192 32c0-17.7 14.3-32 32-32h32v192h-64v-160zM544 0c17.7 0 32 14.3 32 32v464c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-496h32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/person-booth.js
// module id = 1629
// module chunks = 0